import { H7 } from 'foundations-components/transitional/components/H7';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ViewController } from 'foundations-components/transitional/components/ViewController';
import ContentOverview from '../../../components/MostPopularCertificates/ContentOverview';
import { ModalTileSection } from '../../../components/TrackLessonOverviewModal/subcomponents/ModalTileSection';
//@ts-expect-error Could not find declaration file for module
import useMediaQuery from '../../../hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import { EnrollLessonButton, EnrollShortButton, EnrollTrackButton } from '../../userProgress';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import SectionHeading from '../../../components/SectionHeading';
import OverviewModalAssessmentQuizMeContainer from '../../interactiveEducation/components/preAssessment/OverviewModalAssessmentQuizMeContainer';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverviewModalDescriptionSection = ({
  title,
  description,
  duration,
  selectedLanguage,
  availableLanguages,
  availableLanguagesLoading,
  onChangeSelectedLanguage,
  contentList,
  hasCertificate,
  hasStudyGuide,
  type,
  id,
  onEnroll
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  // isQuizMeEnabled is a search param if set to true, the pre-assessment quiz me feature will be enabled within the overview modal. For now its only enabled for lessons overview modal.
  const [{
    isQuizMeEnabled
  }] = useSearchParams();
  const isPreAssessmentEnabled = isQuizMeEnabled === 'true';
  return /*#__PURE__*/_jsxs(View, {
    children: [isPreAssessmentEnabled && type === 'LESSON' ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ModalTileSection, {
        paddingBlockEnd: "400",
        paddingBlockStart: "800",
        paddingInline: "0",
        children: /*#__PURE__*/_jsx(Text, {
          as: isMobile ? 'h4' : 'h1',
          marginBlockEnd: "400",
          children: title
        })
      }), id && /*#__PURE__*/_jsx(OverviewModalAssessmentQuizMeContainer, {
        contentId: id,
        contentType: type,
        language: selectedLanguage,
        onEnroll: onEnroll
      })]
    }) : /*#__PURE__*/_jsxs(ModalTileSection, {
      padding: "0",
      paddingBlockEnd: "400",
      paddingBlockStart: "800",
      children: [/*#__PURE__*/_jsx(Text, {
        as: isMobile ? 'h4' : 'h1',
        marginBlockEnd: "400",
        children: title
      }), type === 'SHORT_FORM_CONTENT' ? /*#__PURE__*/_jsx(EnrollShortButton, {
        id: id || 0,
        onEnroll: onEnroll
      }) : type === 'TRACK' ? /*#__PURE__*/_jsx(EnrollTrackButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      }) : /*#__PURE__*/_jsx(EnrollLessonButton, {
        id: id || 0,
        language: selectedLanguage,
        onEnroll: onEnroll
      })]
    }), /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        paddingBlockEnd: "400",
        paddingBlockStart: "800",
        children: type === 'LESSON' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.overviewModal.lessonDetails"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.overviewModal.courseDetails"
        })
      }), /*#__PURE__*/_jsxs(CardWrapper, {
        children: [/*#__PURE__*/_jsxs(ModalTileSection, {
          paddingBlockEnd: "600",
          children: [/*#__PURE__*/_jsx(H7, {
            paddingBlockEnd: "200",
            children: duration
          }), description]
        }), (availableLanguages || availableLanguagesLoading) && /*#__PURE__*/_jsx(ModalTileSection, {
          paddingBlockEnd: "400",
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(H7, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.overviewModal.languagesAvailable"
              })
            }), availableLanguagesLoading || !availableLanguages ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : /*#__PURE__*/_jsx(ViewController, {
              "data-test-id": "language-view-controller",
              onChange: onChangeSelectedLanguage,
              options: availableLanguages.map(lang => ({
                text: lang.toUpperCase(),
                value: lang
              })),
              size: "extra-small",
              value: selectedLanguage
            })]
          })
        }), type !== 'SHORT_FORM_CONTENT' && /*#__PURE__*/_jsxs(ModalTileSection, {
          children: [/*#__PURE__*/_jsx(H7, {
            marginBlockEnd: "100",
            marginBlockStart: "300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.mostPopularCertificates.includes"
            })
          }), /*#__PURE__*/_jsx(ContentOverview, {
            content: contentList,
            hasCertificate: hasCertificate,
            hasStudyGuide: hasStudyGuide
          })]
        })]
      })]
    })]
  });
};
export default OverviewModalDescriptionSection;